import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DefaultWaveSmallLeaderboardDrop } from "./DefaultWaveSmallLeaderboardDrop";
interface QuorumWaveSmallLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly isApproveWave?: boolean | undefined;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
  readonly onDropClick: () => void;
}
export const QuorumWaveSmallLeaderboardDrop: React.FC<QuorumWaveSmallLeaderboardDropProps> = t0 => {
  const $ = _c(6);
  const {
    drop,
    isApproveWave: t1,
    isVotingClosed: t2,
    isVotingControlsLocked: t3,
    onDropClick
  } = t0;
  const isApproveWave = t1 === undefined ? false : t1;
  const isVotingClosed = t2 === undefined ? false : t2;
  const isVotingControlsLocked = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== drop || $[1] !== isApproveWave || $[2] !== isVotingClosed || $[3] !== isVotingControlsLocked || $[4] !== onDropClick) {
    t4 = <DefaultWaveSmallLeaderboardDrop drop={drop} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked} isApproveWave={isApproveWave} onDropClick={onDropClick} contentPresentation="quorumCompact" />;
    $[0] = drop;
    $[1] = isApproveWave;
    $[2] = isVotingClosed;
    $[3] = isVotingControlsLocked;
    $[4] = onDropClick;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};